<template>
  <v-row dense>
    <v-col cols="12">
      <v-card
        tile
        color="primary"
        class="elevation-0 mb-2"
      >
        <v-card-title
          class="font-weight-medium grey--text pt-1 pb-2"
        >
          {{ title }}
        </v-card-title>
        <v-card-subtitle class="pb-2">
          {{ subtitle }}
        </v-card-subtitle>
      </v-card>

      <v-card class="elevation-0 mt-3" tile>
        <h5>Esta funcionalidad aun no existe.</h5>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapMutations } from 'vuex';
import types from '@/types';

export default {
  name: 'Dashboard',
  data() {
    return {
      title: 'Por hacer',
      subtitle: 'La funcionalidad aun no ha sido creada.',
    };
  },

  methods: {
    ...mapMutations(
      `${types.APP}`, [
        types.SHOW_SUCCESS,
      ],
    ),
    testNotification() {
      this[types.SHOW_SUCCESS]('Casi viajamos en el tiempo.');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/Todo.vue